import React from "react";
import { BrowserRouter as Router, Navigate, Routes, Route } from "react-router-dom";
import LandingScreen from "../modules/landingPage/screens/LandingScreen";
import Dashboard from "../modules/dashboard/screen/DashboardPage";
import Login from "../modules/auth/screens/LoginPage";
import ForgotPassword from "../modules/auth/screens/ForgotPasswordPage";
import ChangePassword from "../modules/auth/screens/ChangePasswordPage";
import Support from "../modules/support/screens/Support";
import KvsSamagamRoutes from "../modules/kvs-samagam/routes";
import StudentHolisticRoutes from "../modules/student-holistic/routes";
import PmShriRoutes from "../modules/pm-shri/routes";
import DikshaRoutes from "../modules/Diksha/routes";
import NishthaRoutes from "../modules/Nishtha/routes";
import UdiseRoutes from "../modules/Udise/routes";
import AttendanceRoutes from "../modules/Attendance/routes";
import ResultRoutes from "../modules/result/routes";
import AnalyticsCopilotRoutes from "../modules/analytics-copilot/routes";
import AdmissionRoutes from "../modules/admission/routes";
import DocumentChatPage from "../modules/document-chat/screens/DocumentChatPage";
import StudentAttendanceRegister from "../modules/Attendance/screens/StudentAttendanceRegister";
import { DashboardCacheProvider } from "../modules/dashboard/context/DashboardContext";
import ProtectedRoute from "./ProtectedRoute";
import PageShell from "../components/layout/PageShell";


const AppRouter: React.FC = () => {
  return (
    <Router>
      <DashboardCacheProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingScreen />} />
          {/* Wrapped in PageShell so Header/Footer stay put across the whole
              login → forgot-password → login journey. LandingScreen supplies
              the same shell when it renders the login form inline. */}
          <Route path="/login" element={<PageShell><Login /></PageShell>} />
          {/* Public by necessity — the user cannot log in to reach it */}
          <Route path="/forgot-password" element={<PageShell><ForgotPassword /></PageShell>} />

          {/* Protected routes - require authentication */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/change-password" element={<PageShell align="start"><ChangePassword /></PageShell>} />
            <Route path="/support" element={<Support />} />
            <Route path="/student-attendance-register" element={<StudentAttendanceRegister />} />
            <Route path="/kvs-samagam/*" element={<KvsSamagamRoutes />} />
            <Route path="/schools" element={<Navigate to="/kvs-samagam/schools" replace />} />
            <Route path="/schools/*" element={<Navigate to="/kvs-samagam/schools" replace />} />
            <Route path="/pm-shri/*" element={<PmShriRoutes />} />
            <Route path="/diksha/*" element={<DikshaRoutes />} />
            <Route path="/student-analytics/*" element={<StudentHolisticRoutes />} />
            <Route path="/nishtha/*" element={<NishthaRoutes />} />
            <Route path="/udise/*" element={<UdiseRoutes />} />
            <Route path="/attendance/*" element={<AttendanceRoutes />} />
            <Route path="/result/*" element={<ResultRoutes />} />
            <Route path="/analytics/*" element={<AnalyticsCopilotRoutes />} />
            <Route path="/admission/*" element={<AdmissionRoutes />} />
            <Route path="/doc-chat" element={<DocumentChatPage />} />
          </Route>
        </Routes>
      </DashboardCacheProvider>
    </Router>
  );
};

export default AppRouter;
